<template>
    <v-main>
        <v-row class="mt-n16">
            <v-col cols="10" class="mb-n16">
                <h2 class="ml-4 mb-7"><v-icon>mdi-cards-playing-outline</v-icon> 시안 확인 알림 연락처</h2>
            </v-col>
            <v-col cols="2">
                <AddNotifyToButton></AddNotifyToButton>
            </v-col>
        </v-row>

        <v-row v-if="notifyToArray.length > 0">
            <v-col cols="12">
                <ul>
                    <li v-for="list in notifyToArray" :key="list.id" class="ml-4 mb-1">
                        <v-chip
                                class="ma-2"
                                close
                                @click:close="deleteNotifyTo(list.id)"
                        >
                            {{ list.phoneNumber }}<strong class="ml-2"> {{ list.name }}</strong>
                        </v-chip>
                    </li>
                </ul>
            </v-col>
        </v-row>

        <v-row v-if="notifyToArray.length == 0">
            <v-col cols="12" sm="6">
                <ul>
                    <li class="ml-4 mb-1">
                        등록된 연락처가 없습니다.
                    </li>
                </ul>
            </v-col>
        </v-row>
    </v-main>

</template>

<script>
import AddNotifyToButton from "@/components/admin/button/AddNotifyToButton";
import axios from "axios";

export default {
    name: 'NotifyToWidget',
    components: {
        AddNotifyToButton
    },
    data: () => ({
        notifyToArray: [],
        groupSetting: {}
    }),
    methods: {
        async getNotifyTo() {
            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/setting/getNotifyTo',
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data != null && response.data.status == '0000'){

                        this.notifyToArray = response.data.data

                    }else{

                        this.notifyToArray = []

                    }

                })
                .catch(() => {

                    //뭔가 실패 시
                    alert('연락처 리스트를 가져오지 못했습니다.')
                    this.$rollbar.error('연락처 리스트 조회 실패', this.$el)

                })
        },
        async deleteNotifyTo(id) {

            if(confirm('정말 삭제하시겠습니까?')){

                return axios({
                    method: 'POST',
                    headers: {
                        'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                    },
                    url: this.$store.getters.getApiUrl + '/api/v1/setting/deleteNotifyTo/' + id,
                    timeout: this.$store.getters.getApiRequestTimeLimit
                })
                .then(response => {

                    if(response.data != null && response.data.status == '0000'){

                        alert(response.data.message)
                        this.getNotifyTo()

                    }else{

                        alert(response.data.message)

                    }

                })
                .catch(() => {

                    //뭔가 실패 시
                    alert('연락처 삭제에 실패했습니다.')
                    this.$rollbar.error('연락처 삭제 실패', this.$el)

                })

            }

        },
    },
    created: function() {
        if(this.$store.getters.getAccessToken != null){
            this.groupSetting = this.$store.getters.getGroupSetting
        }
        this.getNotifyTo()
    }
}
</script>